import React from "react";
import {
  FaBuilding,
  FaClipboardCheck,
  FaHandshake,
  FaHardHat,
  FaHome,
} from "react-icons/fa";
import "./services.css";

const servicesData = [
  {
    title: "Architectural Design",
    description: "Creative and functional designs tailored to every project.",
    icon: FaBuilding,
  },
  {
    title: "Construction",
    description: "High-quality construction with precision and excellence.",
    icon: FaHardHat,
  },
  {
    title: "Interior Design",
    description: "Stylish interiors that reflect your taste and lifestyle.",
    icon: FaHome,
  },
  {
    title: "Project Management",
    description: "End-to-end management ensuring smooth and timely delivery.",
    icon: FaClipboardCheck,
  },
  {
    title: "Consultation",
    description: "Expert guidance to turn your vision into reality.",
    icon: FaHandshake,
  },
];

const Services = () => {
  return (
    <section className="services-main-section">
      <div className="services-shell">
        <p className="services-kicker">
          <span className="services-kicker__line" />
          OUR SERVICES
          <span className="services-kicker__line" />
        </p>
        <h2 className="services-heading">What <b>We Do</b></h2>

        <div className="services-list">
          {servicesData.map((service) => {
            const Icon = service.icon;

            return (
              <article key={service.title} className="service-card">
                <div className="service-icon">
                  <Icon size={38} />
                </div>
                <h3 className="service-title">{service.title}</h3>
                <p className="service-text">{service.description}</p>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
